var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompartir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817",
    transform: "translate(-370.252 -319.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9278",
    "data-name": "Rectangle 9278",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(370.252 319.273)",
    fill: "#e9edef",
    opacity: 0.553
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9280",
    "data-name": "Rectangle 9280",
    width: 22,
    height: 22,
    transform: "translate(380.252 329.273)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10833-2",
    "data-name": "Group 10833",
    transform: "translate(383.591 332.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10813",
    "data-name": "Group 10813",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23816",
    "data-name": "Path 23816",
    d: "M15.32.309a.26.26,0,0,0,0-.089V.189a.314.314,0,0,0-.172-.172h-.031A.256.256,0,0,0,15.028,0H14.97a.386.386,0,0,0-.11.021L.218,5.607a.343.343,0,0,0,0,.638l6.07,2.488L4.6,12.254a.343.343,0,0,0,.484.443l2.4-1.434L9.054,15.1a.341.341,0,0,0,.635-.007L15.3.443a.386.386,0,0,0,.021-.11ZM13.6,1.225,6.676,8.15l-5.4-2.217ZM5.711,11.519,6.741,9.392l.5,1.222Zm3.665,2.519L7.16,8.634l6.925-6.925Z",
    transform: "translate(-0.001 0)",
    fill: "#7c8891",
    stroke: "#7c8891",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompartir);
export default __webpack_public_path__ + "static/media/compartir.afbf59a424f641b571f15fbccdec015c.svg";
export { ForwardRef as ReactComponent };